import { useLang } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { c } = useLang();
  return (
    <footer data-testid="site-footer" className="grid gap-6 border-t border-paper/10 bg-deep3 px-6 py-12 md:grid-cols-3 md:items-center md:px-[4vw]">
      <div className="inline-flex items-center gap-3 text-paper/90">
        <img src="/images/osrelis-mark.png" alt="OSRELIS" className="h-8 w-8 object-contain" />
        <span className="font-sans text-[13px] font-semibold tracking-[0.3em]">OSRELIS</span>
      </div>
      <p className="font-sans text-[9px] uppercase tracking-[0.08em] text-paper/45 md:text-center">{c.footer.copyright}</p>
      <p className="font-sans text-[9px] uppercase tracking-[0.08em] text-paper/45 md:text-right">{c.footer.rights}</p>
    </footer>
  );
};
